import { configureStore } from "@reduxjs/toolkit";
import { userSlice, UserState } from "./getMe";

export function constructStore() {
  return configureStore({
    reducer: userSlice.reducer,
  });
}

export const UserStore = constructStore();

export function getUserState(): UserState {
  return UserStore.getState();
}
